import { Component, OnInit, inject } from '@angular/core';

import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { PermissionService } from './core/services/permission/PermissionService';
import { ThemeService } from './core/services/theme/theme-service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly permissionService = inject(PermissionService);
  private readonly themeService = inject(ThemeService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.permissionService.loadPermissions();
    this.themeService.initializeTheme();
  }

  constructor() {
    this.listenToNavigation();
  }

  private listenToNavigation(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe();
  }
}
